/* global require */
import "core-js/stable"
import "regenerator-runtime/runtime"

import React from 'react'
import { createRoot } from 'react-dom/client'
import Cookies from 'universal-cookie'
import { Provider } from 'react-redux'
import * as $ from 'jquery'

import Root from 'components/Root'
import createRoutes from 'routes'
import config from 'Config'
import store from 'store'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import 'utils/errors'

import 'images/io-loading.gif'
require.context('../src/images/favicons', true)

const startApp = function () {
  const
    mountNode = document.querySelector('#root'),
    history = syncHistoryWithStore(browserHistory, store),
    routes  = createRoutes(store),
    root = createRoot(mountNode)

  root.render(
    <Provider store={ store }>
      <Root history={ history } routes={ routes } />
    </Provider>
  )
}

document.addEventListener("DOMContentLoaded", () => {
  if(localStorage?.getItem('token') || new Cookies().get('token')) {
    startApp() // token ready, let's go!
    return
  }

  // head request to find out if we're logged in despite not having a token
  $.ajax({
    method: 'HEAD',
    url: `${config.ioUrl}/api/v2/sessions`,
    xhrFields: { withCredentials: true }
  }).done(() => {
    // remember this page
    const redir = encodeURIComponent(location.pathname)
    // go to accounts to get a token, then redirect here
    location.href = `${config.ioSignInUrl}?redirect_to=${redir}`
  }).fail(() => {
    // start app without a login
    startApp()
  })
})
